import { render, staticRenderFns } from "./BrokenLinkPopup.vue?vue&type=template&id=75df147d&scoped=true"
import script from "./BrokenLinkPopup.vue?vue&type=script&lang=js"
export * from "./BrokenLinkPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75df147d",
  null
  
)

export default component.exports